import React from "react";
import { Phone, MessageCircle, Mail } from "lucide-react";
import { CONTACT } from "@/i18n/translations";
import { useHome } from "@/i18n/home";

export const ContactDock = () => {
  const d = useHome().dock;
  const items = [
    { key: "phone", icon: Phone, label: d.call, value: CONTACT.phone, href: `tel:${CONTACT.phoneRaw}`, bg: "var(--pt-blue)", fg: "#090A0C" },
    { key: "whatsapp", icon: MessageCircle, label: d.whatsapp, value: CONTACT.phone, href: `https://wa.me/${CONTACT.whatsapp}`, bg: "var(--pt-orange)", fg: "#fff", ext: true },
    { key: "mail", icon: Mail, label: d.mail, value: CONTACT.email, href: `mailto:${CONTACT.email}`, bg: "#090A0C", fg: "#fff" },
  ];
  return (
    <>
      {/* desktop: right edge */}
      <div className="fixed bottom-6 right-3 z-40 hidden flex-col gap-2.5 md:flex" data-testid="contact-dock">
        {items.map((it) => (
          <a
            key={it.key}
            href={it.href}
            {...(it.ext ? { target: "_blank", rel: "noopener noreferrer" } : {})}
            data-testid={`dock-${it.key}`}
            className="group flex h-12 items-center justify-end overflow-hidden rounded-full shadow-[0_8px_24px_rgba(9,10,12,0.25)] transition-[width] duration-300 w-12 hover:w-[290px]"
            style={{ background: it.bg, color: it.fg }}
            aria-label={it.label}
          >
            <span className="whitespace-nowrap pl-5 pr-2 text-sm font-semibold opacity-0 transition-opacity duration-200 group-hover:opacity-100">{it.value}</span>
            <span className="grid h-12 w-12 shrink-0 place-items-center"><it.icon size={20} /></span>
          </a>
        ))}
      </div>

      {/* mobile: bottom bar */}
      <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 gap-2 border-t border-[#E5E7EB] bg-white/90 p-2.5 backdrop-blur-xl md:hidden" data-testid="contact-bar-mobile">
        {items.map((it) => (
          <a
            key={it.key}
            href={it.href}
            {...(it.ext ? { target: "_blank", rel: "noopener noreferrer" } : {})}
            data-testid={`mbar-${it.key}`}
            className="flex items-center justify-center gap-1.5 rounded-full py-3 text-sm font-semibold"
            style={{ background: it.bg, color: it.fg }}
          >
            <it.icon size={16} /> {it.label}
          </a>
        ))}
      </div>
    </>
  );
};
